<div class="container">
    <div class="header">
        <h4 class="title">
            {{ 'alarm-group.dialog.title' | translate }}
        </h4>
    </div>
    <div class="step">
        <div class="content-1">
            <div class="content-title">
                {{ 'alarm-group.dialog.sub-title' | translate }}
            </div>
            <div class="name-input-wrapper">
                <app-channel-text-input
                    data-cy="alarm-group-name-input"
                    [name]="NAME_INPUT"
                    label="alarm-group.dialog.label.name"
                    [value]="data?.name"
                    [maxLength]="NAME_MAX_LENGTH"
                    [placeholder]="'alarm-group.dialog.label.name.placeholder'"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.name"></app-channel-text-input>
            </div>
            <app-textarea-with-error
                data-cy="alarm-group-description-textarea"
                class="input-form"
                [inputValue]="data.description"
                legend="alarm-group.dialog.label.description"
                [validatorFunction]="validatorFunction"
                [propertyName]="DESCRIPTION_INPUT"
                (onInputUpdated)="onTextAreaChange($event)"
                [rows]="7"
                [placeholder]="'alarm-group.dialog.label.description.placeholder'"
            ></app-textarea-with-error>
            <app-list-bubble-selector
                data-cy="alarm-group-category-selector"
                #categoriesSelector
                [title]="'channel-search.dialog.category.title'"
                [elementList]="channelCategories"
                [listBubbleType]="'category'"
                [selectedElements]="selectedCategories"
                (onElementSelected)="updateFilteredCategories($event)"></app-list-bubble-selector>
        </div>
        <div class="footer" *ngIf="!editMode">
            <div class="button-container">
                <div class="left">
                    <div class="button reset" (click)="reset()">
                        {{ 'channel-search.dialog.button.reset' | translate }}
                    </div>
                </div>
                <div class="right">
                    <button class="text-button" (click)="close()">
                        {{ 'dlg.cancel' | translate }}
                    </button>
                    <app-button
                        [disable]="hasErrors"
                        text="alarm-group.dialog.create-button"
                        customFontFamily="NotoSans-SemiBold"
                        size="small"
                        customFontSize="14px"
                        (onClick)="createAlarmGroup()"></app-button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoading" class="loading-container">
        <app-loading-spinner [custom]="true" class="spinner-component" size="80" strokeWidth="3"></app-loading-spinner>
    </div>
</div>
